import {
  EventTriggeringConditionType,
  FetchArtifactCollectionTriggersQueryResult,
  FetchProjectTriggersQueryResult,
  TriggerScopeType,
} from '../../generated/graphql';
import {TriggerDetails} from '../Launch/Triggers/TriggersTable/utilTypes';

export const getTitleAndMessage = (
  eventType: EventTriggeringConditionType,
  artifactCollectionName: string
) => {
  let title = 'Automated Notification';
  let message = 'Event fired';
  if (eventType === EventTriggeringConditionType.LinkModel) {
    title = `New model version linked to the registered model: ${artifactCollectionName}`;
    message = `Insert Artifact Info here`;
  }
  return {title, message};
};

export function getNotificationTriggers(
  artifactCollectionID: string,
  triggersQueryResult: FetchProjectTriggersQueryResult
) {
  // TODO: Add triggers edge from ArtifactCollection to make this cleaner.
  const projectTriggers = triggersQueryResult.data?.project?.triggers ?? [];
  const artifactCollectionScopes = ['ArtifactSequence', 'ArtifactPortfolio'];
  return projectTriggers.filter(t => {
    return (
      t.triggeredAction.__typename === 'NotificationTriggeredAction' &&
      artifactCollectionScopes.includes(t.scope.__typename) &&
      t.scope.id === artifactCollectionID
    );
  });
}

export function getDescription(
  artifactCollectionName: string,
  eventType: EventTriggeringConditionType
) {
  if (eventType === EventTriggeringConditionType.LinkModel) {
    return `New model version linked to "${artifactCollectionName}".`;
  }
  return '';
}

const TriggerScopeTypeMapping: Record<string, TriggerScopeType> = {
  Project: TriggerScopeType.Project,
  ArtifactSequence: TriggerScopeType.ArtifactCollection,
  ArtifactPortfolio: TriggerScopeType.ArtifactCollection,
};

export function getTriggerDetails(
  projectTriggers: FetchProjectTriggersQueryResult,
  collectionTriggers?: FetchArtifactCollectionTriggersQueryResult
): TriggerDetails[] {
  const projectTriggersDetails =
    projectTriggers?.data?.project?.triggers?.map(t => ({
      id: t.id,
      name: t.name,
      scopeType: TriggerScopeTypeMapping[t.scope.__typename] ?? 'PROJECT',
      scopeID: t.scope.id,
    })) ?? [];

  const collectionTriggersDetails =
    collectionTriggers?.data?.artifactCollection?.triggers?.edges?.map(c => ({
      id: c.node.id,
      name: c.node.name,
      scopeType:
        TriggerScopeTypeMapping[c.node.scope.__typename] ??
        'ARTIFACT_COLLECTION',
      scopeID: c.node.scope.__typename !== 'Project' ? c.node.scope.id : '',
    })) ?? [];
  return [...projectTriggersDetails, ...collectionTriggersDetails];
}
